import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MobileFooterComponent } from '../mobile-footer/mobile-footer';
import { DesktopFooterComponent } from '../desktop-footer/desktop-footer';
import { BottomFooterComponent } from '../bottom-footer/bottom-footer';
import { TopFooterComponent } from '../top-footer/top-footer';

@Component({
  selector: 'allas-footer',

  imports: [
    CommonModule,
    MobileFooterComponent,
    DesktopFooterComponent,
    BottomFooterComponent,
    TopFooterComponent,
  ],
  templateUrl: 'footer.html',
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  expandedSections: Record<string, boolean> = {};

  toggleSection(section: string): void {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  // Footer Data
  customerService = [
    { name: 'Contáctanos', href: '/contactanos', active: true },
    { name: 'Mi Cuenta', href: '/login', active: true },
    // { name: 'Rastrear mi Pedido', href: '/rastrear-pedido', active: true },
    {
      name: 'Política de Garantías',
      href: '/privacidad',
      active: true,
    },
    {
      name: 'Política de Cambios',
      href: '/privacidad',
      active: true,
    },
    {
      name: 'Política de Devoluciones',
      href: '/privacidad',
      active: true,
    },
    {
      name: 'Preguntas Frecuentes',
      href: '/preguntas-frecuentes',
      active: true,
    },
  ];

  company = [
    { name: 'Sobre Nosotros', href: '/empresa/sobre-nosotros', active: true },
    { name: 'Nuestras Sucursales', href: '/sucursales', active: true },
    {
      name: 'Trabaja con Nosotros',
      href: '/empresa/bolsa-empleo',
      active: true,
    },
    {
      name: 'Programa de Recompensas',
      href: '/servicios/afiliaciones',
      active: true,
    },
  ];

  legal = [
    { name: 'Términos y Condiciones', href: '/privacidad', active: true },
    {
      name: 'Política de Privacidad',
      href: '/privacidad#privacidad',
      active: true,
    },
    { name: 'Política de Cookies', href: '/privacidad#cookies', active: true },
    { name: 'Aviso Legal', href: '/privacidad#aviso-legal', active: true },
  ];

  cities = [
    { name: 'San Pedro Sula', count: '3 sucursales' },
    { name: 'Tegucigalpa', count: '6 sucursales' },
    { name: 'La Ceiba', count: '1 sucursal' },
    { name: 'El Progreso', count: '1 sucursal' },
    { name: 'Choloma', count: '1 sucursal' },
  ];

  categories = [
    { name: 'Baterías', href: '/bateria/para', active: true },
    { name: 'Repuestos', href: '/repuestos', active: true },
    {
      name: 'Lubricantes y Químicos',
      href: '/repuestos/lubricantes-fluidos-lavado-pegamentos-y-quimicos',
      active: true,
    },
    { name: 'Herramientas', href: '/repuestos', active: false },
    {
      name: 'Accesorios de Interior',
      href: '/repuestos/accesorios-de-interior',
      active: true,
    },
    {
      name: 'Accesorios de Exterior',
      href: '/repuestos/accesorios-de-exterior',
      active: true,
    },
  ];

  services = [
    {
      name: 'Diagnóstico de la Batería',
      href: '/servicios/diagnostico-instalacion-baterias',
      active: true,
    },
    {
      name: 'Instalación de Batería',
      href: '/servicios/diagnostico-instalacion-baterias',
      active: true,
    },
    {
      name: 'Servicio a Domicilio',
      href: '/servicios/entrega-domicilio',
      active: true,
    },
    {
      name: 'Instalación de Limpiaparabrisas',
      href: '/servicios/cambiar-limpiaparabrisas',
      active: true,
    },
    {
      name: 'Instalación de Filtros',
      href: '/servicios/instalacion-filtros',
      active: true,
    },
    {
      name: 'Reciclaje de Baterías',
      href: '/servicios/reciclaje-baterias',
      active: true,
    },
    {
      name: 'Tiendas Allas Cerca de Mi',
      href: '/encuentra-tu-tienda',
      active: true,
    },
    // {
    //   name: 'Talleres Referidos',
    //   href: 'servicios/talleres-referidos',
    //   active: true,
    // },
    {
      name: 'Compras en línea y recoge en tienda',
      href: '/servicios/entrega-domicilio',
      active: true,
    },
    { name: 'Aplicación Móvil', href: '/aplicacion-movil', active: true },
    {
      name: 'Programa de Recompensas o Puntos',
      href: '/servicios/afiliaciones',
      active: true,
    },
    {
      name: 'Cotización por WhatsApp',
      href: '/servicios/cotiza-por-whatsapp',
      active: true,
    },
  ];

  shopping = [
    {
      name: 'Encuentra tu Batería',
      href: '/repuestos/bateria-para-carro-auto-o-camioneta',
      active: true,
    },
    {
      name: 'Batería por marca y modelo',
      href: '/baterias-carros-honduras',
      active: true,
    },
    { name: 'Marca de Vehículo', href: '/comprar/marca', active: true },
    { name: 'Modelo de Vehículo', href: '/comprar/modelo', active: true },
    {
      name: 'Marca de Producto',
      href: '/comprar/marca-producto',
      active: true,
    },
    { name: 'Catálogo o Categorías', href: '/repuestos', active: true },
    {
      name: 'Ofertas y Liquidaciones',
      href: '/bajo-construccion',
      active: false,
    },
    { name: 'Lista de Deseos', href: '/bajo-construccion', active: false },
    { name: 'Mi Carrito', href: '/carrito', active: true },
    {
      name: 'Encuentra tu Tienda',
      href: '/encuentra-tu-tienda',
      active: true,
    },
  ];
}
